import type React from 'react'
import type { HeroProps, HeroCenteredProps } from './types'
import { HeroCentered } from './hero-centered'
import { HeroMediaGrid } from './hero-media-grid'
import { HeroCenterAnnouncement } from './hero-center-announcement'
import { HeroCenterFeatures } from './hero-center-features'
import { HeroBento } from './hero-bento'

export type { HeroProps }

export function Hero(props: HeroProps): React.ReactElement {
  switch (props.variant) {
    case 'centered': {
      const { variant, ...rest } = props
      return <HeroCentered {...rest} />
    }
    case 'center-image-features': {
      const { variant, ...rest } = props
      return <HeroCenterFeatures {...rest} />
    }
    case 'image-grid': {
      const { variant, ...rest } = props
      return <HeroMediaGrid {...rest} />
    }
    case 'center-announcement': {
      const { variant, ...rest } = props
      return <HeroCenterAnnouncement {...rest} />
    }
    case 'code-bento': {
      const { variant, ...rest } = props
      return <HeroBento {...rest} />
    }
    default: {
      // All variants are handled above; this is a runtime fallback for an
      // unknown variant — render the simple centered hero.
      const { variant, ...rest } = props as HeroCenteredProps
      return <HeroCentered {...rest} />
    }
  }
}

export default Hero
